module.exports = __webpack_public_path__ + "img/laboratorio4_4-3_2048.16b048e4.jpg";